import { Dialog } from '@mui/material';
import React from 'react';
import { subHeadingStyle } from 'views/pages/manage/unAssigned/studentFinanceApproval/epmrCancellation/constant';
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";

const ItemListingDialog = ({
    items = [],
    open,
    setOpen,
    title = "Select Item Number",
    onItemSelect = () => { },
}) => {

    const closeDialog = () => {
        setOpen(false);
    };

    return (
        <Dialog
            open={open}
            PaperProps={{ sx: { maxWidth: "unset", borderRadius: "12px" } }}
        >
            <div className='p-4 confirm-rejection-dialog'>
                <div className="d-flex justify-content-end">
                    <CrossIcon onClick={closeDialog} />
                </div>

                <div style={{ width: '500px' }}>
                    <div className="header d-flex justify-content-center mb-3">{title}</div>
                    <table className="table table-striped">
                        <tbody>
                            {items?.length === 0 ? (
                                <tr>
                                    <td className='text-center'>No items found</td>
                                </tr>
                            ) : (
                                items.map((item, index) => (
                                    <tr
                                        key={`${item.itemNo}-${index}`}
                                        className='cursor link'
                                        onClick={() => {
                                            onItemSelect(item.itemNo);
                                            setOpen(false);
                                        }}
                                    >
                                        <td style={subHeadingStyle} className='text-center'>
                                            {item.itemNo} &nbsp;
                                            {item.materialShortText ? ` - ${item.materialShortText}` : ''}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </Dialog>
    );
};

export default ItemListingDialog;
